import styled from "styled-components";
import { DESKTOP } from "../../../styles/breakpoints";
import { Text } from "../../../components/common";

export const OnboardingDescription = styled(Text)`
  font-size: 1rem;
  line-height: 150%;
  text-align: start;
`;

export const OnboardingTitle = styled(OnboardingDescription)`
  font-weight: 700;
  font-size: 1.5rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 40rem;

  .button-container {
    display: flex;
    flex-direction: column;
    margin: 2rem 0;
    gap: 1.5rem;
  }

  @media screen and (min-width: ${DESKTOP}) {
    .button-container {
      flex-direction: row;
    }

    span {
      text-align: left;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  margin-top: 10px;
`;
